<template>
  <div>
    <el-drawer :title="steps[currentStep].title" :visible.sync="visible" :direction="drawerAttribute.direction"
      :size="drawerAttribute.size" @close="handleClose" :before-close="handleClose" custom-class="after-sale-drawer"
      append-to-body>
      <div class="after-sale-type">
        <div class="select-type">
          <OTBaseButton :text="afterSaleType.label" />
        </div>
        <!-- <div class="describe">{{ steps[currentStep].description }}</div> -->
        <div class="empty"></div>
      </div>
      <!-- 步骤内容区域 -->
      <div class="step-content" @scroll="handleScroll" ref="stepContent">
        <!-- 第一步：基本信息 -->
        <div v-if="currentStep === 0" class="step-panel">
          <div class="select-all-content" v-if="initialData.goods.length > 1">
            <span class="iconfont-ot-website select-all-icon" @click="toggleSelectAll">{{ isAllSelected ? `&#xe6ef;` :
              `&#xe6ec;` }}</span>
            <span class="select-all-text">全选</span>
            <span>已选 {{ selectedData.length }} 件</span>
          </div>

          <div class="orders">
            <div class="orders-item" v-for="(item, index) in initialData.goods" :key="index">
              <div class="select-icon" @click="toggleSelect(item.id)">
                <span class="iconfont-ot-website ">
                  {{
                    selectedData.some((selected) => selected.id === item.id)
                      ? `&#xe6ef;`
                      : `&#xe6ec;`
                  }}
                </span>
              </div>
              <OrderItem :item="item" :isShowProductStatusLabel="true" :isShowProductLabel="true"
                :order-status="initialData.status" />
            </div>
          </div>
        </div>

        <!-- 第二步：退货信息 -->
        <div v-if="currentStep === 1" class="step-panel">
          <div class="step-panel-title" v-if="afterSaleTypeKey === 1">
            填写退货物流信息
          </div>
          <div class="step-panel-content">
            <el-form :model="afterSaleForm" ref="afterSaleForm">
              <div class="" v-if="afterSaleTypeKey === 1">
                <el-form-item prop="delivery_type_value">
                  <div class="form-item-label">快递类型 <span>*</span></div>
                  <el-select placeholder="请选择快递类型" v-model="afterSaleForm.delivery_type_value"
                    :popper-append-to-body="false" v-if="!isMobile">
                    <el-option v-for="(item, index) in afterSalesOptions.deliveryTypes" :key="index" :label="item.label"
                      :value="item.value">
                      <p class="title">{{ item.label }}</p>
                    </el-option>
                  </el-select>
                  <div v-if="isMobile" @click="handleOpenDrawer({ type: 'delivery_type_value' })">
                    <el-input v-model="afterSaleForm.delivery_type_label" readonly placeholder="请选择快递类型"></el-input>
                    <i class="iconfont icon-right-arrow">&#xe628;</i>
                  </div>
                </el-form-item>
                <el-form-item prop="logistics_no">
                  <div class="form-item-label">物流单号 <span>*</span></div>
                  <el-input v-model="afterSaleForm.logistics_no" placeholder="请输入物流单号"></el-input>
                </el-form-item>
                <div class="return-information">
                  <div class="ri-base-info">
                    <div class="form-item-label">退货地址</div>
                    <div class="content">
                      <div class="item">
                        联系人：{{ afterSalesTipsJson.contacts }}
                      </div>
                      <div class="item">电话：{{ afterSalesTipsJson.tel }}</div>
                      <div class="item">
                        退货地址：{{ afterSalesTipsJson.address }}
                      </div>
                      <span class="iconfont-ot-website" @click="
                        copyText(
                          '联系人:' +
                          afterSalesTipsJson.contacts +
                          ' 电话：' +
                          afterSalesTipsJson.tel +
                          ' 退货地址：' +
                          afterSalesTipsJson.address
                        )
                        ">&#xe606;</span>
                    </div>
                  </div>
                  <div class="ri-note">
                    <div class="form-item-label">退货注意事项：</div>
                    <div class="content">
                      Onitsuka
                      Tiger鬼塚虎官方线上店提供“7天无理由退货服务”，退回商品应与签收状态相同，同时随单寄回物品
                      (如有防尘袋、配件、赠品、购物清单、发票等)
                      也应一同寄回，避免影响您的正常退款
                    </div>
                  </div>
                </div>
              </div>
              <div class="return-goods-list">
                <div class="i-good-info" v-for="(goodsItem, goodsIndex) in selectedData" :key="goodsIndex">
                  <div class="good-info">
                    <OrderItem :item="goodsItem" :isShowProductStatusLabel="true" :isShowProductLabel="true"
                      :order-status="initialData.status" />
                    <div class="del-icon" @click="openDelItemTip(goodsItem.id)" v-if="selectedData.length > 1">
                      <span class="iconfont-ot-website">&#xe67f;</span>
                    </div>
                  </div>
                  <div class="rgl-base-infos">
                    <div class="rgl-base-info">
                      <div class="form-item-label">售后原因 <span>*</span></div>
                      <el-form-item :prop="`${goodsItem.chargeback_reason_value}`" :rules="{
                        required: true,
                        message: '请选择售后原因',
                        trigger: 'change',
                      }">
                        <el-select placeholder="请选择售后原因" :popper-append-to-body="false"
                          v-model="goodsItem.chargeback_reason_value" v-if="!isMobile">
                          <el-option v-for="(afterSalesReasonItem,
                            index) in afterSalesOptions.reasonTypes" :key="'reason' + index"
                            :label="afterSalesReasonItem.label" :value="afterSalesReasonItem.value">
                            <p class="title">
                              {{ afterSalesReasonItem.label }}
                            </p>
                          </el-option>
                        </el-select>
                        <div @click="
                          handleOpenDrawer({
                            type: 'chargeback_reason_value',
                            item: goodsItem,
                          })
                          " v-if="isMobile" style="width: 100%;" class="mobile-chargeback_reason_value">
                          <el-input :value="getReasonLabel(goodsItem.chargeback_reason_value)
                            " readonly contenteditable placeholder="请选择售后原因"></el-input>
                          <i class="iconfont icon-right-arrow">&#xe628;</i>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="rgl-base-info">
                      <div class="">退款金额</div>
                      <div class="">￥{{ goodsItem.row_amount }}</div>
                    </div>
                    <div class="rgl-base-info">
                      <div class="">退回积分</div>
                      <div class="">
                        <span class="iconfont-ot-website">&#xe680;</span>{{ goodsItem.pointsDeducted }}积分
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div v-if="(currentStep === 1 && (afterSaleTypeKey ===  1 || selectedData.length > 2)) && !isScrolled" class="info-tip">
          <img class="image" src="https://assetsprod.onitsukatiger.com/assets/other/afterSales-tip.gif" alt="填写提示" />
        </div>
      </div>
      <div class="drawer-footer">
        <div class="step-actions">
          <OTBaseButton v-if="currentStep < steps.length - 1" text="下一步" width="100%" :disabled="!selectedData.length"
            buttonType="primary" @onClick="nextStep" />
          <div class="step-actions" v-if="currentStep === steps.length - 1">
            <div class="footer-base-info">
              共{{ calcQuantity(selectedData) }}件，退回总金额￥{{
                calcTotal.totalAmount
              }}，退回积分{{ calcTotal.totalPoints }}
            </div>
            <OTBaseButton text="提交申请" buttonType="primary" :disabled="!isFormValid" width="100%"
              @onClick="submitForm" />
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer custom-class="after-sale-select-drawer" :visible.sync="deliveryTypeDrawerVisible" direction="btt"
      title="请选择快递类型">
      <div class="empty"></div>
      <div class="select-drawer-content">
        <div class="select-item" v-for="(item, index) in afterSalesOptions.deliveryTypes" :key="index"
          @click="handleSelectOption(item)">
          <span class="label"> {{ item.label }} </span>
          <span class="iconfont-ot-website ">
            {{
              afterSaleForm.delivery_type_value === item.value
                ? `&#xe6ef;`
                : `&#xe6ec;`
            }}
          </span>
        </div>
      </div>
    </el-drawer>
    <el-drawer custom-class="after-sale-select-drawer" :visible.sync="chargebackReasonVisible" direction="btt"
      title="请选择售后原因" v-if="chargebackReasonVisible">
      <div class="product-select-item">
        <div v-for="(item, index) in selectedData" :key="index" @click="handleSelectItem(item)" :class="[
          'item',
          currentSelectItem.id === item.id ? 'active-item' : '',
        ]">
          <img :src="item.cover" class="item-img" />
          <span :class="item.chargeback_reason_value && 'is-selected'" v-if="item.chargeback_reason_value">已选</span>
        </div>
      </div>
      <div class="empty"></div>
      <div class="select-drawer-content">
        <div class="after-sales-options">
          <div class="after-sales-option-item" v-for="item in afterSalesOptions.reasonTypes" :key="item.value">
            <div class="title">{{ item.label }}</div>
            <span class="iconfont-ot-website select-all-icon" @click="handleSelectOption(item)">{{
              item.value === currentSelectItem.chargeback_reason_value
                ? `&#xe6ef;`
                : `&#xe6ec;`
            }}
            </span>
          </div>
        </div>
      </div>
      <div class="drawer-footer level-2-footer">
        <div class="step-actions">
          <OTBaseButton text="下一步" width="100%" buttonType="primary" @onClick="handleNextStep" />
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import OTBaseButton from "@/components/baseCom/button.vue";
import OrderItem from "@/components/orderItem.vue";
import types from "@/store/types";
import utilsOrder from "@/utils/order";
import api from "@/utils/api";
import utils from "@/utils";
import { captureManualError } from "@/sentry/index";
import { toNumber } from "lodash";

export default {
  components: { OTBaseButton, OrderItem },

  name: "StepDrawer",
  props: {
    // 控制抽屉显示/隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // 抽屉方向
    // 初始表单数据，从外部传入
    initialData: {
      type: Object,
    },
    // 步骤配置
    steps: {
      type: Array,
      default: () => [
        { title: "选择售后商品", description: "填写退款基本信息" },
        { title: "确认退款信息", description: "填写退货方式及物流信息" },
      ],
    },
    // 步骤间距
    stepSpace: {
      type: [String, Number],
      default: "auto",
    },
  },
  data() {
    return {
      // 当前步骤索引
      allOrderStatus: utilsOrder.OrderStatus,
      drawerAttribute: { direction: "rtl", size: "40%" },
      currentStep: 0,
      afterSaleType: null, // 售后类型
      afterSalesTipsJson: null,
      selectedData: [],
      afterSalesOptions: {},
      afterSaleForm: {},
      deliveryTypeDrawerVisible: false,
      chargebackReasonVisible: false,
      currentSelectItem: null,
      currentSelectType: "",
      afterSaleFormRules: {
        delivery_type_value: [
          { required: true, message: "请选择快递类型", trigger: "blur" },
        ],
        logistics_no: [
          { required: true, message: "请输入物流单号", trigger: "blur" },
        ],
      },
      isScrolled: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.afterSaleTypeAction();
      this.getAfterSalesTipsJson();
      this.getAfterSalesOptions();
      this.setDrawerAttribute();
    },
    handleOpenDrawer(data) {
      const { type, item } = data;
      this.currentSelectType = type;
      if (type === "delivery_type_value") {
        this.deliveryTypeDrawerVisible = true;
      } else {
        this.currentSelectItem = item || null;
        this.chargebackReasonVisible = true;
      }
    },
    handleSelectOption(selectedItem) {
      if (this.currentSelectType === "delivery_type_value") {
        this.afterSaleForm.delivery_type_value = selectedItem.value;
        this.afterSaleForm.delivery_type_label = selectedItem.label;
        this.deliveryTypeDrawerVisible = false;
      } else if (
        this.currentSelectType === "chargeback_reason_value" &&
        this.currentSelectItem
      ) {
        const index = this.selectedData.findIndex(
          (item) => item.id === this.currentSelectItem.id
        );

        if (index !== -1) {
          this.selectedData[index].chargeback_reason_value = selectedItem.value;
          this.currentSelectItem.chargeback_reason_value = selectedItem.value;
        }
      }
    },

    // 多个选择售后原因选中项
    handleSelectItem(item) {
      this.currentSelectItem = item;
    },

    // mob选择售后下一步
    handleNextStep() {
      const emptyReasonItem = this.selectedData.find(
        (item) => !item.chargeback_reason_value
      );

      if (emptyReasonItem) {
        this.currentSelectItem = emptyReasonItem;
        this.handleSelectItem(emptyReasonItem);
      } else {
        this.chargebackReasonVisible = false;
        this.currentSelectType = "";
        this.currentSelectItem = null;
      }
    },
    getReasonLabel(value) {
      if (!value) return "";
      const reason = this.afterSalesOptions.reasonTypes.find(
        (item) => item.value === value
      );
      return reason ? reason.label : "";
    },
    // 获取json
    getAfterSalesTipsJson() {
      api[types.GET_AFTER_SALES_TIPS_JSON]()
        .then((res) => {
          this.afterSalesTipsJson = res.data;
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },

    // 获取退款原因文本
    getAfterSalesOptions() {
      api[types.AFTER_SALES_OPTIONS]()
        .then((res) => {
          const deliveryTypes = res.data?.delivery_type;
          const reasonTypes = res.data?.reason_type.find(
            (item) => item.type === this.afterSaleTypeKey
          );
          this.afterSalesOptions = {
            deliveryTypes,
            reasonTypes: reasonTypes.list,
          };
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err);
        });
    },

    // 下一步
    nextStep() {
      if (this.currentStep < this.steps.length) {
        this.currentStep++;
        this.scrollToTop();
      }
    },

    // 提交表单
    submitForm() {
      this.$refs.afterSaleForm.validate((valid) => {
        if (!valid) {
          this.$message.error("请完善退货物流信息");
          return false;
        }

        // 校验每个商品的退款原因
        let isValid = true;
        for (let i = 0; i < this.selectedData.length; i++) {
          const item = this.selectedData[i];
          if (!item.chargeback_reason_value) {
            isValid = false;
            this.$message.error(`请选择"${item.name}"的售后原因`);
            break;
          }
        }
        const list = this.selectedData.map((item) => {
          return {
            item_id: toNumber(item.item_id),
            chargeback_reason: item.chargeback_reason_value,
          };
        });

        if (isValid) {
          const params =
            this.afterSaleTypeKey === 1
              ? {
                order_no: this.initialData.order_no,
                chargeback_type: this.afterSaleTypeKey,
                list,
                delivery_type: this.afterSaleForm?.delivery_type_value,
                logistics_no: this.afterSaleForm?.logistics_no,
              }
              : {
                order_no: this.initialData.order_no,
                chargeback_type: this.afterSaleTypeKey,
                list,
              };
          this.handleRmaSave(params);
        }
      });
    },
    handleRmaSave(params) {
      api[types.APPLY_RMA_SAVE](params)
        .then((rmaSaveRes) => {
          const { data, code } = rmaSaveRes;
          if (code === 1) {
            this.$message.success("已申请售后");
            // TODO:是否上报ga
            if (data?.id) {
              this.$router.push({
                name: "afterSaleDetail",
                path: "/myaccount/afterSaleDetail",
                query: { rma_id: data.id, id: this.initialData.order_no },
              });
            }
          } else {
            this.$message({
              type: "error",
              message: rmaSaveRes.message || "申请售后失败",
            });
          }
        })
        .finally(() => {
          this.handleClose();
        });
    },

    // 关闭抽屉
    handleClose() {
      this.clearData();
      this.$emit("update:visible", false);
    },

    // 清除数据
    clearData() {
      this.currentStep = 0;
      this.selectedData = [];
      this.afterSaleType = null;
      this.currentSelectType = "";
      this.currentSelectItem = null;
    },

    // 滚动到顶部
    scrollToTop() {
      this.$nextTick(() => {
        document.querySelector(".step-content").scrollTop = 0;
      });
    },

    // 勾选商品
    toggleSelect(id) {
      const existingIndex = this.selectedData.findIndex(
        (item) => item.id === id
      );
      const originalItem = this.initialData.goods.find(
        (item) => item.id === id
      );

      if (existingIndex > -1) {
        this.selectedData.splice(existingIndex, 1);
      } else if (originalItem) {
        this.selectedData.push({
          ...originalItem,
          chargeback_reason_value: "",
        });
      }
    },

    // 全选/全不选
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedData = [];
      } else {
        this.selectedData = this.initialData.goods.map((item) => ({
          ...item,
          chargeback_reason_value: "",
        }));
      }
    },

    // 删除已选项
    toggleDelItem(id) {
      const index = this.selectedData.findIndex((item) => item.id === id);
      if (index > -1) {
        this.selectedData.splice(index, 1);
      }

      if (this.currentSelectItem?.id === id) {
        this.currentSelectItem = this.selectedData[0] || null;
      }

      if (this.selectedData.length === 0) {
        this.handleClose();
        this.currentSelectType = "";
        this.currentSelectItem = null;
      }
    },
    openDelItemTip(id) {
      this.$confirm("确定要删除此退款商品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.toggleDelItem(id);

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => { });
    },

    // 根据订单状态设置售后类型
    // TODO: afterSaleType 售后类型待联调，待定
    afterSaleTypeAction() {
      this.afterSaleType = utilsOrder.getAfterSaleType(
        this.initialData.status_code
      );
    },

    // 复制文本
    copyText(text) {
      utils.copyText(text);
    },

    // 设置mob抽屉属性
    setDrawerAttribute() {
      if (utils.isMobile() || utils.isWXBrowser()) {
        this.drawerAttribute = { direction: "btt", size: "80%" };
      }
    },

    // 处理滚动事件
    handleScroll(event) {
      // 检查目标元素是否为 .step-content
      if (event.target.classList.contains('step-content')) {
        // 检查是否有垂直滚动
        if (event.target.scrollTop > 10) {
          this.isScrolled = true;
        }
      }
    },

    // 重置滚动状态
    resetScrollState() {
      this.isScrolled = false;
    },
  },

  computed: {
    isAllSelected() {
      return (
        this.initialData.goods &&
        this.selectedData.length === this.initialData.goods.length &&
        this.initialData.goods.length > 0
      );
    },

    afterSaleTypeKey() {
      return utilsOrder.getAfterSaleType(this.initialData.status_code).key;
    },

    // 添加表单校验是否通过的计算属性
    isFormValid() {
      const isMainFormValid =
        this.afterSaleForm.delivery_type_value &&
        this.afterSaleForm.logistics_no;

      const isGoodsValid =
        this.selectedData.length > 0 &&
        this.selectedData.every((item) => item.chargeback_reason_value);

      if (this.afterSaleTypeKey === 1) {
        return isMainFormValid && isGoodsValid;
      }
      return isGoodsValid;
    },

    calcTotal() {
      return this.selectedData.reduce(
        (acc, item) => {
          acc.totalPoints += Number(item.pointsDeducted) || 0;
          acc.totalAmount += Number(item.row_amount) || 0;
          return acc;
        },
        { totalPoints: 0, totalAmount: 0 }
      );
    },
    calcQuantity() {
      return utils.calcQuantity;
    },
    isMobile() {
      return utils.isMobile() || utils.isWXBrowser();
    },
  },
  watch: {
    "initialData.goods": {
      handler(newGoods, oldGoods) {
        // 只有当数组长度发生变化或首次加载时才执行
        if (!oldGoods || newGoods.length !== oldGoods.length) {
          if (newGoods && newGoods.length === 1) {
            this.$nextTick(() => {
              this.toggleSelect(newGoods[0].id);
            });
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .after-sale-drawer {
  .el-drawer__header {
    padding: 60px 40px 40px 40px;
    margin-bottom: 2px;
    font-size: 18px;
    color: #212322;
    font-weight: 500;
  }

  .el-dialog__close {
    color: #212322 !important;
  }

  .after-sale-type {
    display: flex;
    flex-direction: column;
    padding: 0 40px 0 40px;

    .select-type {
      display: flex;
      flex-direction: row;
      gap: 10px;

      .default {
        border-color: #212322;
        border-radius: 2px;
      }

      .active {
        border-color: #000;
        border-radius: 2px;
      }
    }

    .describe {
      color: #999999;
      margin-top: 8px;
    }
  }

  .empty {
    width: 100%;
    height: 10px;
    background: #f8f8f8;
    margin-top: 24px;
  }

  .step-content {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    padding: 40px 40px 100px 40px;

    .select-all-content {
      padding-bottom: 24px;
      padding-left: 2px;
    }

    .select-all-icon,
    .select-icon {
      cursor: pointer;
    }

    .select-all-text {
      padding: 0 8px;
      margin-right: 8px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 12px;
        background-color: #000;
      }
    }

    .orders {
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding-left: 2px;

      .orders-item {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        gap: 14px;

        .select-icon {
          width: 20px;

          .iconfont-ot-website {
            position: absolute;
            top: 26px;
          }
        }

        .goods-items {
          flex: 1;
        }
      }
    }
  }

  .step-panel-title {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .confirm-info {
    padding: 10px 0;
  }

  .confirm-info p {
    margin: 10px 0;
    line-height: 1.6;
  }

  .label {
    display: inline-block;
    width: 100px;
    color: #606266;
  }

  .return-information {
    margin-bottom: 40px;

    .ri-base-info {
      .content {
        border: 1px solid #000;
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        position: relative;

        .iconfont-ot-website {
          position: absolute;
          right: 12px;
          top: 12px;
          cursor: pointer;
        }
      }

      margin-bottom: 10px;
    }

    .ri-note {
      color: #666666;

      .form-item-label {
        color: #666666;
      }
    }
  }

  .return-goods-list {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .i-good-info {
      display: flex;
      flex-direction: column;
      border-top: 1px solid #d3d3d5;
      padding-top: 24px;

      &:first-child {
        border-top: none;
        padding-top: 10px;
      }

      .good-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      .goods-items {
        flex: 0 1 90%;
      }

      .del-icon {
        // flex: 10%;
        cursor: pointer;
        padding-top: 3px;
      }

      .rgl-base-infos {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .rgl-base-info,
        .el-form-item__content {
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
        }

        .el-form-item {
          width: 70%;
          margin-bottom: 0;
        }
      }
    }
  }

  .step-panel-content {
    width: 100%;

    ::placeholder {
      color: #666;
    }

    .el-select {
      width: 100%;
    }

    .el-input__inner {
      border: 1px solid #acacac;
      border-radius: 0;
      height: 40px;
      line-height: 40px;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      padding-left: 16px;
      padding-right: 36px;

      ::placeholder {
        color: #666;
      }
    }

    .el-input__suffix {
      right: 14px;

      .el-select__caret {
        font-size: 16px;
        color: #212322;
      }
    }

    .el-popper {
      margin: 0;
      border-radius: 0;
      box-shadow: none;
      border: 1px solid #acacac;

      &[x-placement^="bottom"] {
        border-top-width: 0;
      }

      .el-select-dropdown__wrap {
        max-height: 180px;

        .el-select-dropdown__item {
          height: 40px;
          border-bottom: 1px solid #eee;
          padding: 12px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #666;

          .title {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
          }

          .sub-title {
            margin-top: 4px;
            font-size: 12px;
            font-weight: 400;
            line-height: 18px;
          }

          .selected-icon {
            display: none;
            font-size: 24px;
            line-height: 24px;
          }

          &.selected {
            color: #333;

            .title {}

            .sub-title {
              color: #666;
            }

            .selected-icon {
              display: block;
              color: #1c1b1f;
            }
          }
        }
      }

      .el-scrollbar__bar.is-vertical {
        width: 2px;

        .el-scrollbar__thumb {
          background: #0000003d;
        }
      }

      .popper__arrow {
        display: none;
      }
    }

    .form-item-label {
      line-height: 32px;

      span {
        color: red;
        font-size: 16px;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .empty {
    height: 6px !important;
  }

  .select-type {
    .ot-base-button {
      width: 50%;
    }
  }

  ::v-deep .after-sale-drawer {
    height: auto !important;
    max-height: calc(100vh - 100px);

    .el-drawer__header {
      padding: 20px 20px 20px 20px;
      font-size: 14px;
    }

    .after-sale-type {
      padding: 0 20px 10px 20px;
    }

    .step-content {
      max-height: calc(100vh - 300px);
      padding: 20px 20px 130px 20px;
      position: relative;

      .info-tip {
        position: absolute;
        bottom: 124px;
        left: 0;
        right: 0;
        width: 100%;
        background: transparent;
        background-color: transparent;
        display: flex;
        align-content: center;
        justify-content: center;

        .image {
          width: 112px;
          height: auto;
          display: block;
        }
      }

      .orders {
        gap: 20px;
        padding-left: 2px;

        .orders-item {
          flex-direction: row-reverse;

          .select-icon {
            margin-right: 0;

            .iconfont-ot-website {
              top: 36px;
            }
          }
        }
      }
    }

    .icon-right-arrow {
      position: absolute;
      right: 8px;
      transform: rotate(90deg);
    }

    .step-panel-content {
      .el-input__inner {
        border: none;
        border-bottom: 1px solid #212322;
        padding: 0px 30px 0 0;
        // text-align: right;
      }

      .el-input__suffix {
        right: 0;
      }

      .mobile-chargeback_reason_value {
        line-height: 30px;

        .el-input {
          line-height: 30px;
        }

        .el-input__inner {
          border-bottom: none;
          height: 30px;
          line-height: 1;
          text-align: right;
        }
      }
    }

    .ot-base-button {
      padding: 10px 50px;
      margin: 0;
      border-radius: 2px;
    }
  }

  ::v-deep .after-sale-select-drawer {
    height: auto !important;
    padding: 16px;

    .el-drawer__header {
      padding: 0;
      margin-bottom: 2px;
      font-size: 18px;
      color: #212322;
    }

    .product-select-item {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 10px;
      padding-top: 10px;

      .item {
        width: 66px;
        height: 66px;
        border: 1px solid #ccc;
        padding: 6px;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }
      }

      .active-item {
        border-color: #000;
      }

      .is-selected {
        position: absolute;
        top: 4px;
        left: 4px;
        color: #fff;
        background: #21232299;
        border-radius: 8px;
        font-size: 10px;
        padding: 3px 6px;
        text-align: center;
        line-height: 1;
      }
    }

    .select-drawer-content {
      padding: 10px 2px 50px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      max-height: calc(100vh - 400px);
      overflow: auto;

      .select-item {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
      }

      .after-sales-options {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        padding: 10px 2px 100px;

        .after-sales-option-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: row;
          width: 100%;
          gap: 20px;
        }
      }

      .ot-base-button {
        width: 100%;
        position: fixed;
        bottom: 0;
      }
    }
  }

  .drawer-footer {
    padding: 20px 20px;
  }

  .level-2-footer {
    padding: 21px 0;
  }
}

@media (min-width: 769px) {
  .drawer-footer {
    border-top: 1px solid #d3d3d5;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 20px 40px;
  }
}

::v-deep .el-drawer {
  text-align: left; // 订单详情页 全局 center

  .el-drawer__body {
    position: relative;
  }
}

.drawer-footer {
  border-top: 1px solid #d3d3d5;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;

  .step-actions {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    .footer-base-info {
      padding-bottom: 10px;
    }
  }
}
</style>
